export var PreviewModels;
(function (PreviewModels) {
    class PreviewConfiguration {
        constructor(data) {
            this.spaceDomains = data.spaceDomains;
            this.previewUrlPatterns = data.previewUrlPatterns;
            this._raw = data._raw;
        }
    }
    PreviewModels.PreviewConfiguration = PreviewConfiguration;
})(PreviewModels || (PreviewModels = {}));
//# sourceMappingURL=preview.models.js.map